export default __webpack_public_path__ + "static/media/body_clowncostume.51e2ade5.png";